import React from 'react';
import './Button.css';

const Button = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'medium',
  disabled = false,
  className = '',
  ...props
}) => {
  const buttonClasses = `
    glass-button 
    glass-button--${variant} 
    glass-button--${size} 
    ${disabled ? 'glass-button--disabled' : ''} 
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <div className="glass-button-wrap">
      <button
        type={type}
        className={buttonClasses}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        <span>{children}</span>
      </button>
      <div className="glass-button-shadow"></div>
    </div>
  );
};

export default Button;
